import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Spinner, Container } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

const API_URL = (process.env.REACT_APP_API_URL || "/").replace(/\/$/, '');

const CargarEvaluacion = () => {
  const [categorias, setCategorias] = useState([]);
  const [categoriaId, setCategoriaId] = useState('');
  const [modulos, setModulos] = useState([]);
  const [moduloId, setModuloId] = useState('');
  const [preguntas, setPreguntas] = useState([]);
  const [preguntaActual, setPreguntaActual] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    fetch(`${API_URL}/api/capacitaciones/categorias`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setCategorias(data.data);
      });
  }, []);

  const cargarModulosPorCategoria = async (id) => {
    setModuloId('');
    setModulos([]);
    try {
      const token = localStorage.getItem('token');
      
      const res = await fetch(`${API_URL}/api/capacitaciones/modulos/categoria/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await res.json();
      if (data.success) setModulos(data.data);
    } catch (err) {
      toast.error('No se pudieron cargar los módulos');
    }
  };

  const agregarPregunta = () => {
    if (preguntas.length >= 10) {
      toast.warning('Máximo 10 preguntas');
      return;
    }
    setPreguntas([...preguntas, {
      tipo: 'multiple',
      pregunta: '',
      opcion_a: '',
      opcion_b: '',
      opcion_c: '',
      opcion_d: '',
      correcta: 'a'
    }]);
    setPreguntaActual(preguntas.length);
  };

  const handlePreguntaChange = (field, value) => {
    const nuevas = [...preguntas];
    let actual = { ...nuevas[preguntaActual], [field]: value };

    // 🔧 Si el tipo cambia, reiniciamos los campos según el tipo
    if (field === 'tipo') {
      if (value === 'vf') {
        actual = {
          tipo: 'vf',
          pregunta: '',
          correcta: 'true'
        };
      } else if (value === 'multiple') {
        actual = {
          tipo: 'multiple',
          pregunta: '',
          opcion_a: '',
          opcion_b: '',
          opcion_c: '',
          opcion_d: '',
          correcta: 'a'
        };
      }
    }

    nuevas[preguntaActual] = actual;
    setPreguntas(nuevas);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!moduloId || preguntas.length === 0) {
      toast.error('Seleccioná módulo y agregá al menos una pregunta');
      return;
    }

    const incompletas = preguntas.some(p => !p.pregunta || !p.correcta || (p.tipo === 'multiple' && (!p.opcion_a || !p.opcion_b || !p.opcion_c || !p.opcion_d)));
    if (incompletas) {
      toast.error('Completá todas las preguntas correctamente');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/capacitaciones/evaluacion/cargar`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ modulo_id: moduloId, preguntas })
      });

      const data = await res.json();
      if (!data.success) throw new Error();

      toast.success('✅ Evaluación guardada');
      setModuloId('');
      setCategoriaId('');
      setModulos([]);
      setPreguntas([]);
      setPreguntaActual(0);
    } catch {
      toast.error('❌ Error al guardar evaluación');
    } finally {
      setLoading(false);
    }
  };

  const pregunta = preguntas[preguntaActual];

  return (
    <div>
      <Container className="py-4">
        <Card className="p-4">
          <h5 className="mb-3">Cargar Evaluación</h5>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Categoría</Form.Label>
              <Form.Select value={categoriaId} onChange={(e) => {
                setCategoriaId(e.target.value);
                cargarModulosPorCategoria(e.target.value);
              }} required>
                <option value="">Seleccionar categoría</option>
                {categorias.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Módulo</Form.Label>
              <Form.Select value={moduloId} onChange={(e) => setModuloId(e.target.value)} required>
                <option value="">Seleccionar módulo</option>
                {modulos.map(m => (
                  <option key={m.id} value={m.id}>{m.titulo}</option>
                ))}
              </Form.Select>
            </Form.Group>

            {pregunta && (
              <Card className="mb-3 p-3 bg-light">
                <h6>Pregunta {preguntaActual + 1}</h6>

                <Form.Group className="mb-2">
                  <Form.Label>Tipo de pregunta</Form.Label>
                  <Form.Select value={pregunta.tipo} onChange={(e) => handlePreguntaChange('tipo', e.target.value)}>
                    <option value="multiple">Multiple Choice</option>
                    <option value="vf">Verdadero / Falso</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Control
                    placeholder="Texto de la pregunta"
                    value={pregunta.pregunta}
                    onChange={(e) => handlePreguntaChange('pregunta', e.target.value)}
                  />
                </Form.Group>

                {pregunta.tipo === 'multiple' ? (
                  <>
                    {['a', 'b', 'c', 'd'].map(op => (
                      <Form.Group key={op} className="mb-2">
                        <Form.Label>Opción {op.toUpperCase()}</Form.Label>
                        <Form.Control
                          value={pregunta[`opcion_${op}`]}
                          onChange={(e) => handlePreguntaChange(`opcion_${op}`, e.target.value)}
                        />
                      </Form.Group>
                    ))}
                    <Form.Group className="mb-2">
                      <Form.Label>Respuesta correcta</Form.Label>
                      <Form.Select
                        value={pregunta.correcta}
                        onChange={(e) => handlePreguntaChange('correcta', e.target.value)}
                      >
                        <option value="a">Opción A</option>
                        <option value="b">Opción B</option>
                        <option value="c">Opción C</option>
                        <option value="d">Opción D</option>
                      </Form.Select>
                    </Form.Group>
                  </>
                ) : (
                  <Form.Group className="mb-2">
                    <Form.Label>Respuesta correcta</Form.Label>
                    <Form.Select
                      value={pregunta.correcta}
                      onChange={(e) => handlePreguntaChange('correcta', e.target.value)}
                    >
                      <option value="true">Verdadero</option>
                      <option value="false">Falso</option>
                    </Form.Select>
                  </Form.Group>
                )}
              </Card>
            )}

            <div className="d-flex justify-content-between mb-3">
              <Button variant="secondary" onClick={() => setPreguntaActual(Math.max(preguntaActual - 1, 0))} disabled={preguntaActual === 0}>
                ← Anterior
              </Button>
              <Button variant="secondary" onClick={() => setPreguntaActual(Math.min(preguntaActual + 1, preguntas.length - 1))} disabled={preguntaActual >= preguntas.length - 1}>
                Siguiente →
              </Button>
              <Button variant="info" onClick={agregarPregunta} disabled={preguntas.length >= 10}>
                + Agregar pregunta
              </Button>
            </div>

            <Button type="submit" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
              Guardar evaluación
            </Button>
          </Form>
        </Card>
        <ToastContainer />
      </Container>
    </div>
  );
};

export default CargarEvaluacion;
